import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss', '../input.scss']
})
export class InputTextComponent {
  
  @Input() 
  public label: string = "Test";

  @Input()
  public inputValue: string = "";

  @Output() save = new EventEmitter();

  constructor() { }

  emit(){
    console.log(this.inputValue)
    this.save.emit(this.inputValue)
  }
}
